import styles from "./UploadFile.module.css";
import APIService from "../../Service/APIService";
import React from "react";
import { message, Flex, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export default function FileUpload({
  label,
  uploadedFiles = [],
  setUploadedFiles,
  multiple = true,
  maxFiles = null,
}) {
  const [loading, setLoading] = React.useState(false);
  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter(
      (file) =>
        file.type === "application/pdf" && file.size <= 4 * 1024 * 1024,
    );
    if (validFiles.length !== files.length) {
      message.error("Only PDF files up to 4MB are allowed.");
      return;
    }

    const nextFiles =
      typeof maxFiles === "number" && maxFiles > 0
        ? validFiles.slice(0, maxFiles)
        : validFiles;

    setUploadedFiles(nextFiles);
  };

  const removeFile = (index) => {
    const nextFiles = Array.isArray(uploadedFiles)
      ? uploadedFiles.filter((_, i) => i !== index)
      : [];
    setUploadedFiles(nextFiles);
  };

  const downloadFile = async (file) => {
    if (!file?.blobName) {
      const blobUrl = URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = file?.name || "invoice.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
      return;
    }

    setLoading(true);
    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(file.blobName);

    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      setLoading(false);
      return;
    }
    // download the file from Azure Blob Storage
    const link = document.createElement("a");
    link.href = sasUrl;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // hide loader
    setLoading(false);
  }

  return (
    <div className={styles.fileUploadSection}>
      {loading && (
        <Flex align="center" gap="middle">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
            fullscreen
          />
        </Flex>
      )}
      <label className={styles.label}>{label}</label>

      <div className={styles.fileUploadContainer}>
        {/* Drag & Drop Area */}
        <div className={styles.dragDropArea}>
          <input
            type="file"
            accept="application/pdf"
            className={styles.fileInput}
            multiple={multiple}
            onChange={handleFileUpload}
          />
          <svg
            className={styles.fileIcon}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M2.99991 10.3327V6.33268C2.99991 4.85935 4.19324 3.66602 5.66657 3.66602H8.26791C9.07724 3.66602 9.84124 4.03268 10.3479 4.66335L11.1519 5.66602H18.3332C19.8066 5.66602 20.9999 6.85935 20.9999 8.33268V10.3327M3.60257 10.3327H20.3972C21.7119 10.3327 22.6679 11.578 22.3292 12.8473L20.8612 18.3527C20.5506 19.5207 19.4932 20.3327 18.2852 20.3327H5.71591C4.50791 20.3327 3.45057 19.5207 3.13991 18.3527L1.67191 12.8473C1.33324 11.578 2.29057 10.3327 3.60391 10.3327H3.60257Z"
              stroke="#303030"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <p className={styles.dragDropText}>Drag or click to upload file</p>
          <p className={styles.fileFormat}>PDF format, up to 4MB</p>
        </div>

        {/* Uploaded Files List */}
        <div className={styles.uploadedFiles}>
          {uploadedFiles.map((file, index) => (
            <div key={index} className={styles.uploadedFileItem}>
              <span className={styles.fileIcon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <path
                    d="M10.1067 4.16637H7.83341C7.46541 4.16637 7.16675 3.86771 7.16675 3.49971V1.23438"
                    stroke="#303030"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1.83337 9.49935V2.49935C1.83337 1.76268 2.43004 1.16602 3.16671 1.16602H6.89071C7.06737 1.16602 7.23737 1.23602 7.36204 1.36135L9.97137 3.97068C10.0967 4.09602 10.1667 4.26535 10.1667 4.44202V9.49935C10.1667 10.236 9.57004 10.8327 8.83337 10.8327H3.16671C2.43004 10.8327 1.83337 10.236 1.83337 9.49935Z"
                    stroke="#303030"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span
                className={styles.fileName}
                style={{ cursor: "pointer" }}
                onClick={() => downloadFile(file)}
              >
                {file.name}
              </span>
              <span className={styles.removeFileIcon} onClick={() => removeFile(index)}>
                <img src="/RemoveFile.svg" alt="Remove file" />
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
